<template>
  <fragment>
    <Button v-b-modal.customized-modal class="right-side">Create Period</Button>

    <b-modal
      id="customized-modal"
      title="Create Period"
      no-close-on-backdrop
      centered
      @ok="
        evt => {
          const temp = $emit('onSubmit', this.form);
          // Hide the modal manually
          this.$nextTick(() => {
            this.$bvModal.hide('modal-prevent-closing');
          });
        }
      "
    >
      <b-form-group label="Period of the review session" label-for="id-period">
        <b-form-select id="id-period" v-model="form.period" :options="options" />
      </b-form-group>
    </b-modal>
  </fragment>
</template>

<script>
import Button from '@/components/Button';

export default {
  name: 'CreateReviewSessionForm',
  components: { Button },
  data() {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    return {
      form: {
        period: '',
      },
      options: months.map(m => ({ value: m, text: m })),
    };
  },
};
</script>
